module.exports = __webpack_public_path__ + "0445422871e656fdd25443a16adeaa37.svg";